import { Action, handleActions } from 'redux-actions';
import { MenuItem } from '../contentful/contentfulClient';
import { menuInitialState, MenuState } from './MenuState';
import { MenuActionType } from './MenuActions';

const menuReducer = handleActions<MenuState, any>(
    {
        [MenuActionType.DATA_LOAD_START]: (state: MenuState) => (
            {
                ...state,
                loaded: false,
                loading: false,
                menuItems: []
            }
        ),
        [MenuActionType.DATA_LOADING]: (state: MenuState) => (
            {
                ...state,
                loaded: false,
                loading: true
            }
        ),
        [MenuActionType.DATA_LOAD_SUCCESS]: (state: MenuState, action: Action<Array<MenuItem>>) => (
            {
                ...state,
                loaded: true,
                loading: false,
                menuItems: action.payload!
            }
        ),
        [MenuActionType.DATA_LOAD_FAILED]: (state: MenuState) => (
            {
                ...state,
                loaded: false,
                loading: false,
                menuItems: []
            }
        ),
        [MenuActionType.BAR_EXPANDED]: (state: MenuState, action: Action<boolean>) => (
                {
                    ...state,
                    expanded: action.payload || false
                }
        )

    },
    menuInitialState
);

export default menuReducer;


// WEBPACK FOOTER //
// ./src/menu/MenuReducer.ts